import { Star, Quote } from "lucide-react";

const STORIES = [
  {
    name: "Sarah K.",
    location: "Pā‘ia, Maui",
    quote:
      "Three weeks in and my knees feel ten years younger. The PEMF + HBOT combo cleared up an old surfing injury that two specialists couldn't.",
    avatar:
      "https://images.unsplash.com/photo-1543572591-adeaf7cb67df?w=160&q=80",
  },
  {
    name: "David M.",
    location: "Kula, Maui",
    quote:
      "I come in tired, I leave with a quiet mind. The lounge is the only place on island where I actually let myself slow down.",
    avatar:
      "https://images.pexels.com/photos/17573018/pexels-photo-17573018.jpeg?w=160",
  },
  {
    name: "Elena R.",
    location: "Ha‘ikū, Maui",
    quote:
      "The red light has changed my skin and my sleep. The team treats me like family — every visit feels like I'm exactly where I should be.",
    avatar:
      "https://images.pexels.com/photos/28400611/pexels-photo-28400611.jpeg?w=160",
  },
];

export default function Testimonials() {
  return (
    <section
      id="stories"
      data-testid="testimonials-section"
      className="relative bg-stone text-bone py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 mll-reveal">
          <div className="lg:col-span-5">
            <p className="text-[11px] uppercase tracking-[0.28em] font-semibold text-clay-soft">
              Results in the Community
            </p>
            <h2 className="mt-4 font-serif font-medium text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
              What members{" "}
              <em className="italic font-normal text-clay-soft">notice</em>{" "}
              first.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pl-10 flex lg:items-end">
            <p className="text-base sm:text-lg text-bone/75 leading-relaxed max-w-xl">
              We don&rsquo;t do hype. These are real changes from members who
              show up consistently — sleep, mobility, mood, and recovery, in
              roughly that order.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mll-stagger">
          {STORIES.map((s, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-bone/[0.04] border border-bone/10 p-8 sm:p-10 hover:bg-bone/[0.07] transition-colors"
            >
              <Quote className="w-6 h-6 text-clay-soft" />
              <div className="mt-4 flex items-center gap-1">
                {[...Array(5)].map((_, j) => (
                  <Star
                    key={j}
                    className="w-3.5 h-3.5 fill-clay-soft text-clay-soft"
                  />
                ))}
              </div>
              <p className="mt-6 font-serif italic text-lg sm:text-xl text-bone leading-snug">
                &ldquo;{s.quote}&rdquo;
              </p>
              <div className="mt-8 pt-6 border-t border-bone/10 flex items-center gap-4">
                <img
                  src={s.avatar}
                  alt={s.name}
                  className="w-11 h-11 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold tracking-tight">
                    {s.name}
                  </p>
                  <p className="text-xs text-bone/60 mt-0.5">{s.location}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-14 mll-reveal">
          <a
            href="https://g.page/r/CQ00mgBadve8EAE/review"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="leave-review-link"
            className="mll-link text-[12px] uppercase tracking-[0.22em] font-semibold text-bone/85 hover:text-clay-soft"
          >
            Leave a review on Google →
          </a>
        </div>
      </div>
    </section>
  );
}
